var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "shadow rounded-lg"
  }, [_vm.data ? _c('YTable', {
    attrs: {
      "data": _vm.data || []
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function (props) {
        var _props$rowData$filter, _props$rowData$filter2, _props$rowData$filter3, _props$rowData$filter4, _props$rowData$filter5, _props$rowData$filter6, _props$rowData$filter7, _props$rowData$filter8, _props$rowData$filter9, _props$rowData$filter10, _props$rowData$filter11, _props$rowData$filter12, _props$rowData$filter13, _props$rowData$filter14, _props$rowData$filter15, _props$rowData$filter16, _props$rowData$filter17, _props$rowData$filter18, _props$rowData$filter19;
        return [_c('td', [_c('div', {
          staticClass: "flex flex-col w-40"
        }, [_c('p', {
          staticClass: "font-semibold text-blue-700"
        }, [_vm._v(_vm._s(props.rowData.label))]), _c('p', {
          staticClass: "text-xs text-gray-600"
        }, [_vm._v("RTB-" + _vm._s(props.rowData.id))])])]), _c('td', {
          staticClass: "font-semibold text-gray-900"
        }, [_vm._v(" $" + _vm._s(props.rowData.bid.toFixed(2)) + " ")]), _c('td', {
          staticClass: "font-semibold text-gray-900"
        }, [_vm._v(" " + _vm._s(props.rowData.destination_url) + " ")]), _c('td', [_c('ToggleButton', {
          staticStyle: {
            "margin": "0px"
          },
          attrs: {
            "sync": true,
            "color": _vm.toggleColors,
            "labels": {
              checked: 'Active',
              unchecked: 'Paused'
            },
            "width": 90,
            "height": 35,
            "font-size": 12
          },
          on: {
            "change": function ($event) {
              return _vm.updateStatus($event, props.rowData);
            }
          },
          model: {
            value: props.rowData.active,
            callback: function ($$v) {
              _vm.$set(props.rowData, "active", $$v);
            },
            expression: "props.rowData.active"
          }
        })], 1), _c('td', [(_props$rowData$filter = props.rowData.filters) !== null && _props$rowData$filter !== void 0 && _props$rowData$filter.countryCodes ? _c('span', {
          staticClass: "block flex gap-1"
        }, _vm._l(props.rowData.filters.countryCodes, function (geo) {
          return _c('Tag', {
            key: geo,
            attrs: {
              "color": geo.startsWith('!') ? 'red' : 'green'
            }
          }, [_vm._v(_vm._s(geo))]);
        }), 1) : _vm._e()]), _c('td', {
          class: _vm.getTextColor((_props$rowData$filter2 = props.rowData.filters) === null || _props$rowData$filter2 === void 0 ? void 0 : _props$rowData$filter2.domains)
        }, [_vm._v(" " + _vm._s((_props$rowData$filter3 = props.rowData.filters) === null || _props$rowData$filter3 === void 0 ? void 0 : (_props$rowData$filter4 = _props$rowData$filter3.domains) === null || _props$rowData$filter4 === void 0 ? void 0 : _props$rowData$filter4.join(', ')) + " ")]), _c('td', {
          class: _vm.getTextColor((_props$rowData$filter5 = props.rowData.filters) === null || _props$rowData$filter5 === void 0 ? void 0 : _props$rowData$filter5.referers)
        }, [_vm._v(" " + _vm._s((_props$rowData$filter6 = props.rowData.filters) === null || _props$rowData$filter6 === void 0 ? void 0 : (_props$rowData$filter7 = _props$rowData$filter6.referers) === null || _props$rowData$filter7 === void 0 ? void 0 : _props$rowData$filter7.join(', ')) + " ")]), _c('td', {
          class: _vm.getTextColor((_props$rowData$filter8 = props.rowData.filters) === null || _props$rowData$filter8 === void 0 ? void 0 : _props$rowData$filter8.ips)
        }, [_vm._v(" " + _vm._s((_props$rowData$filter9 = props.rowData.filters) === null || _props$rowData$filter9 === void 0 ? void 0 : (_props$rowData$filter10 = _props$rowData$filter9.ips) === null || _props$rowData$filter10 === void 0 ? void 0 : _props$rowData$filter10.join(', ')) + " ")]), _c('td', {
          class: _vm.getTextColor((_props$rowData$filter11 = props.rowData.filters) === null || _props$rowData$filter11 === void 0 ? void 0 : _props$rowData$filter11.keywords)
        }, [_vm._v(" " + _vm._s((_props$rowData$filter12 = props.rowData.filters) === null || _props$rowData$filter12 === void 0 ? void 0 : (_props$rowData$filter13 = _props$rowData$filter12.keywords) === null || _props$rowData$filter13 === void 0 ? void 0 : _props$rowData$filter13.join(', ')) + " ")]), _c('td', {
          class: _vm.getTextColor((_props$rowData$filter14 = props.rowData.filters) === null || _props$rowData$filter14 === void 0 ? void 0 : _props$rowData$filter14.subIds)
        }, [_vm._v(" " + _vm._s((_props$rowData$filter15 = props.rowData.filters) === null || _props$rowData$filter15 === void 0 ? void 0 : (_props$rowData$filter16 = _props$rowData$filter15.subIds) === null || _props$rowData$filter16 === void 0 ? void 0 : _props$rowData$filter16.join(', ')) + " ")]), _c('td', {
          class: _vm.getTextColor((_props$rowData$filter17 = props.rowData.filters) === null || _props$rowData$filter17 === void 0 ? void 0 : _props$rowData$filter17.reservedUrls)
        }, [_vm._v(" " + _vm._s((_props$rowData$filter18 = props.rowData.filters) === null || _props$rowData$filter18 === void 0 ? void 0 : (_props$rowData$filter19 = _props$rowData$filter18.reservedUrls) === null || _props$rowData$filter19 === void 0 ? void 0 : _props$rowData$filter19.join(', ')) + " ")]), _c('td', {
          staticStyle: {
            "padding": "0"
          }
        }, [_c('v-popover', {
          class: ['sidebar-user-popover'],
          attrs: {
            "offset": "10",
            "placement": "left-start",
            "autoHide": true,
            "popoverClass": "",
            "popoverBaseClass": "popover-menu sidebar-popover-menu",
            "popoverInnerClass": "popover-menu-inner animated animated-speed1 fadeIn"
          }
        }, [_c('YButton', {
          staticClass: "btn btn-transparent btn-rounded tooltip-target text-gray-700"
        }, [_c('Icon', {
          attrs: {
            "name": "dotsVertical",
            "size": 4
          }
        })], 1), _c('template', {
          slot: "popover"
        }, [_c('div', {
          staticClass: "list-group"
        }, [[_c('button', {
          staticClass: "text-blue-500 hover:bg-blue-100 list-group-item list-group-item-action",
          on: {
            "click": function ($event) {
              return _vm.openEditModal(props.rowData);
            }
          }
        }, [_c('span', {
          staticClass: "flex items-center"
        }, [_c('Icon', {
          staticClass: "mr-2",
          attrs: {
            "name": "pencil",
            "size": 4
          }
        }), _vm._v("Edit ")], 1)]), _c('ClickAndReplace', {
          attrs: {
            "duration": 3000
          },
          scopedSlots: _vm._u([{
            key: "replacement",
            fn: function () {
              return [_c('button', {
                staticClass: "bg-red-500 text-white hover:bg-red-600 list-group-item list-group-item-action",
                on: {
                  "click": function ($event) {
                    return _vm.deleteCampaignRtb(props.rowData);
                  }
                }
              }, [_vm._v(" Confirm Delete ")])];
            },
            proxy: true
          }], null, true)
        }, [_c('button', {
          staticClass: "text-red-500 hover:bg-red-100 list-group-item list-group-item-action"
        }, [_c('span', {
          staticClass: "flex items-center"
        }, [_c('Icon', {
          staticClass: "mr-2",
          attrs: {
            "name": "trashCanOutline",
            "size": 4
          }
        }), _vm._v("Delete ")], 1)])])]], 2)])], 2)], 1)];
      }
    }], null, false, 2270270531)
  }, [_c('template', {
    slot: "header-row"
  }, [_c('th'), _c('th', [_vm._v("BID")]), _c('th', [_vm._v("Destination Url")]), _c('th', [_vm._v("Active")]), _c('th', [_vm._v("Country Codes")]), _c('th', [_vm._v("Domains")]), _c('th', [_vm._v("Referers")]), _c('th', [_vm._v("IPs")]), _c('th', [_vm._v("Keywords")]), _c('th', [_vm._v("subIds")]), _c('th', [_vm._v("Reserved Urls")]), _c('th')])], 2) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }